import { render, staticRenderFns } from "./BooleanColumn.vue?vue&type=template&id=02e84ef6&scoped=true&"
import script from "./BooleanColumn.vue?vue&type=script&lang=js&"
export * from "./BooleanColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e84ef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
